import {RouterView} from 'vue-router'

// HuntRoutes all routes of hunts
export const HuntRoutes = [
  {
    path: '/h',
    name: 'Hunt',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'HuntList',
        redirect: () => {
          return {
            name: 'Index',
          }
        },
      },
      {
        path: ':id',
        component: RouterView,
        children: [
          {
            path: '',
            name: 'HuntDetail',
            redirect: () => {
              return {
                name: 'Index',
              }
            },
          },
          {
            path: 'report',
            component: RouterView,
            children: [
              {
                path: 'consumable',
                name: 'HuntReportConsumable',
                component: () => import('@pages/standard-report-consumable'),
                meta: {},
              },
              {
                path: 'mileage',
                name: 'HuntReportMileage',
                component: () => import('@pages/standard-report-mileage/index'),
                meta: {},
              },
              {
                path: 'chassis',
                name: 'HuntReportChassis',
                component: () => import('@pages/standard-report-chassis/index.vue'),
                meta: {},
              },
            ],
          },
        ],
      },
    ],
  },
]

